import React from 'react';
import "./index.css";

export default function() {
  return (
    <div className="tos">
      <h1>Terms and Conditions Taptivate, LLC.</h1>

      <h3>Acceptance 1.1:</h3>
      
      <p>Taptivate, LLC. provides businesses and organizations with a variety of products and services and related offerings, features and functionalities (individually, a "Product" and collectively, the "Products"). </p>
      
      <p>By creating an account, viewing videos, making a purchase, downloading our software, or otherwise visiting or using our Services, you accept this Agreement and consent to contract with us electronically.</p>
      
      <p>If you are an entity other than a natural person, the person who registers the account or otherwise uses our Services must have the authority to bind the entity. In this context, “you” means both the entity and each person who is authorized to access the account.</p>
      
      <p>Taptivate may update this Agreement by posting a revised version on the Taptivate Platform. By continuing to use our services, you accept any revised Agreement.</p>
      
      <h3>Our Services 1.2:</h3>
      
      <p>Through the patented Taptivate Platform and the creation of customized NFC Tags and Landing pages, our services include but are not limited to: </p>
      
      <ol>
        <li>Marketing </li>
        <li>Advertising</li>
        <li>Client Promotional Offerings</li>
        <li>Uploading and Streaming Videos</li>
        <li>Access Directions</li>
        <li>Cross and Upselling </li>
        <li>Enhancing the Unboxing Moment</li>
        <li>Making Purchases </li>
        <li>Offering Savings/Coupons  </li>
        <li>Offering Reorder Opportunities</li>
        <li>‘Liking’ and ‘Sharing’ on Social Media</li>
        <li>Charitable Communications</li>
        <li>Education</li>
        <li>Participating</li>
        <li>Signing Up or Redeeming</li>
        <li>Gaming</li>
        <li>Facilitating Returns</li>
        <li>Augmented Reality Features</li>
      </ol>
      
      <p>The features available to you will depend on your chosen plan. We may change features from time to time. If you have a paid account, we commit to providing the core features of your plan during your current service period.</p>
      
      <p>1) Utilizing Taptivate’s NFC Tags for marketing purposes such as, communicating your brand message or experience and or services to your customers. </p>
      
      <p>2) Utilizing Taptivate’s NFC Tags for advertising purposes such as, creating awareness for your brand and or services to your customers, creating advertising material and content to share with your consumers. </p>
      
      <p>3) Utilizing Taptivate’s NFC Tags for promotional purposes such as, creating awareness and communicating promotions for your brand and/or services to your customers. </p>
      
      <p>4) Utilizing Taptivate’s NFC Tags for creating and uploading video in order to demonstrate or create awareness for your brand and/or services to your customers. </p>
      
      <p>5) Utilizing Taptivate’s NFC Tags for the purpose of product directions and education, creating more awareness for your brand and/or services to your customers. </p>
      
      <p>6) Utilizing Taptivate’s NFC Tags for upselling and cross-selling purposes in order to generate business and sales, creating awareness for your brand and/or services to your customers.</p>
      
      <p>7) Utilizing Taptivate’s NFC Tags for the Unboxing Experience and creating more awareness for your brand and/or services to your customers, punctuating and enhancing the Unboxing Moment. </p>
      
      <p>8) Utilizing Taptivate’s NFC Tags enhances the moment of the Unboxing Experience and creates an opportunity for your brand and/or services to allow your clientele to continue purchasing other items, extending the products’ life cycle. </p>
      
      <p>9) Utilizing Taptivate’s NFC Tags allows your customers to save by offering coupons and other promotions to their customers. </p>
      
      <p>10) Utilizing Taptivate’s NFC Tags allows your customers to reorder by providing an easy, accessible, convenient and fast way to do business through Taptivate’s NFC Tags platform.</p>
      
      <p>11) Utilizing Taptivate’s NFC Tags allows you to expand your social media network through liking and sharing different content available through the use of the platform.  </p>
      
      <p>12) Utilizing Taptivate’s NFC Tags allows your customers to Make A Difference by creating awareness or choosing to make donations to corporate charities and social causes </p>
      
      <p>13) Utilizing Taptivate’s NFC Tags allows your customers to Learn More through company Reviews and Ratings, Assembly and Use Instructions</p>
      
      <p>14) Utilizing Taptivate’s NFC Tags allows your customers to Participate in Trials and Surveys.</p>
      
      <p>15) Utilizing Taptivate’s NFC Tags allows your customers to take advantage of your loyalty programs and the associated opportunities to Sign Up or Redeem Points.</p>
      
      <p>16) Utilizing Taptivate’s NFC Tags allows your customers to participate in Contests, Sweepstakes and Gamification of all types.</p>
      
      <p>17) Utilizing Taptivate’s NFC Tags allows your customers to Facilitate Returns speedily and efficiently and track their progress.</p>
      
      <p>18) Utilizing Taptivate’s NFC Tags allows your customers a gateway to all the benefits and features of an Augmented Reality Experience.  </p>
      
      <h3>Accounts 1.3:</h3>
      
      <p><strong>Registration</strong>: You may create an account to use certain features we offer. To do so, you must provide an email address. You consent to receive notices from Taptivate, LLC. at this email address.</p>
      
      <p><strong>Organizational Accounts</strong>: Corporate and other organizational users must publicly display the legal name of their entity on their public account profile. </p>
      
      <p><strong>Team Members</strong>: Certain subscription plans may allow you to grant other registered users (<strong>“team members”</strong>) access to the account. Both you and each team member is deemed a party to this Agreement. You are responsible for the actions of your team members and must monitor their access and usage.</p>
      
      <p><strong>Account Security</strong>: You are responsible for all activity that occurs under your account, including unauthorized activity. You must safeguard the confidentiality of your account credentials. If you are using a computer that others have access to, you must log out of your account after each session. If you become aware of unauthorized access to your account, you must change your password and notify us immediately.</p>
      
      <h3>Subscription Plans 1.4:</h3>
      
      <p><strong>Plan Types</strong>: We offer paid subscriptions that allow you to upload and share content. You may purchase a <strong>“Starter”</strong> a <strong>“Small Business”</strong> a <strong>“Business Pro”</strong> or a <strong>“Customized”</strong> plan where you sign up and pay online. Advertised prices and features may change as defined in our price list and plan. There is a minimal rights use of the platform of $.15 per tag for all tags not ordered through Taptivate.</p>
      
      <p><strong>Fees</strong>: You must pay all fees (plus any taxes) during your subscription period and any renewal periods. Our fees may include a fixed monthly or annual fee plus direct fees for the costs of the tags.</p>
      
      <p><strong>Free trials and Promotions</strong>: We may offer free-trial or discounted subscriptions. When a free-trial period ends, your paid subscription begins (unless you have cancelled) and you must pay the full monthly or annual fee. If we provide a discount for the first subscription period, you must pay the discounted fee; in any renewal, you must pay the full fee.</p>
      
      <h3>Acceptable Use Policy 1.5:</h3>
      
      <p>We may allow you to upload or publish (collectively, to <strong>"submit"</strong>) content such as videos, images, and text (collectively, <strong>"content"</strong>). Taptivate, LLC. may (but is not obligated to) monitor your account, content, and conduct, regardless of your privacy settings. </p>
      
      <h3>Licenses Granted by you 1.6:</h3>
      
      <p>As between you and Taptivate, LLC., you own and will retain ownership of all intellectual property rights in and to the content you submit. In order to allow Taptivate, LLC. to host and stream your content, you grant Taptivate, LLC. the permission to host and stream your content. </p>
      
      <h3>Account Profile 1.7: </h3>
      
      <p>You grant Taptivate, LLC. permission to use your name, likeness, trademarks, logos, or other identifiers used by you in your account profile for the purpose of displaying such properties to the public or the audiences you have specified. You may revoke the foregoing permission by deleting your account.</p>
      
      <h3>Your Obligation 1.8:</h3>
      
      <p>For each piece of content that you submit to or through Taptivate, LLC., you represent and warrant that:</p>
      <ul>
      	<li>You have the right to submit the content to Taptivate, LLC. and grant the licenses herein;</li>
      	<li>Taptivate, LLC. will not need to obtain licenses from any third party or pay royalties to any third party with respect to permitted distribution of the content;</li>
      	<li>The content does not, and will not, infringe any third party's rights, including intellectual property rights and privacy rights; and</li>
      	<li>The content complies with this Agreement and all applicable laws.</li>
      </ul>
      
      <h3>Credit Card and Billing Policy 1.9:</h3>
      
      <p>Taptivate, LLC. Platform accepts all forms of Credit Card for payments. Your payment method is saved automatically. You can update your payment method at any time. This agreement is for a period of one year and will be automatically renewed. It is cancelable by either party on 90 day’s written notice.  Written notice may be sent to info@taptivate.co.</p>
      
      <p>You can remove any saved credit cards on the Payment methods tab in your Billing Settings and replace with a new credit card.</p>
      
      <h3>Term and Termination 1.10:</h3>
      
      <p>This Agreement begins when you first use our services and continues so long as you use our service or have an account with us. Paid accounts will continue for the subscription period. Taptivate, LLC. may terminate this Agreement at any time by providing thirty (30) days’ written notice. If you breach this Agreement, Taptivate, LLC. may, at its option: (a) terminate this Agreement immediately, with or without advance written notice; (b) suspend, delete, or limit access to your account or any content within it; and (c) to the extent permitted by applicable law, retain any amounts payable to you (which you forfeit). If Taptivate, LLC. deletes your account for breach, you may not re-register.</p>
      
      <h3>Code of Conduct 1.11</h3>
      
      <p>Please take these rules seriously and take them to heart, just understand them and try to respect the spirit in which they were created.</p>
      
      <p>Nudity or sexual content</p>
      
      <p>The Taptivate Platform is not for pornography or sexually explicit content. Also, be advised that we work closely with law enforcement and we report child exploitation</p>
      
      <p>Harmful or dangerous content</p>
      
      <p>Do not post content that encourage others to do things that might cause them to get badly hurt. Content showing such harmful or dangerous acts will be removed depending on their severity.</p>
      
      <p>Hateful content</p>
      
      <p>Our products are platforms for free expression. But we do not support content that promotes or condones violence against individuals or groups based on race or ethnic origin, religion, disability, gender, age, nationality, veteran status, caste, sexual orientation, or gender identity, or content that incites hatred on the basis of these core characteristics. </p>
      
      <p>Violent or graphic content</p>
      
      <p>It is not okay to post violent content that's primarily intended to be shocking, sensational, or gratuitous. </p>
      
      <p>Harassment and cyberbullying</p>
      
      <p>It’s not ok to post abusive contents. If harassment crosses the line into a malicious attack it can be reported and may be removed. </p>
      
      <p>Threats</p>
      
      <p>Things like predatory behavior, stalking, threats, harassment, intimidation, invading privacy, revealing other people's personal information, and inciting others to commit violent acts or to violate the Terms of Use are taken very seriously. Anyone caught doing these things may be permanently banned from Taptivate.</p>
      
      <p>Copyright</p>
      
      <p>Respect copyright. Only upload content that you made or that you're authorized to use. This means don't upload content you didn't make, or use content that someone else owns the copyright to, such as music tracks, snippets of copyrighted programs, or videos made by other users, without necessary authorizations.</p>
      
      <p>Impersonation</p>
      
      <p>Accounts that are established to impersonate another channel or individual may be removed.</p>

    </div>
  );
}